import { getSessionStorage, setSessionStorage } from '../base/storage'
import Agent from '../agent'
import knbUse, { wxReady } from '../knb/knb-use'
import { reportWarn } from '../owl'
import { isNodeProd } from '../base/env'

export interface Coords {
  lat?: number
  lng?: number
}

// app中
// phx_lat 和 phx_lng 为真实值 * 1000000
// lat 和 lng 为真实值
// cookie 中有 latlng 值为: lat,lng,timestamp, 示例: 11.11111,11.11111,1463722883632
// eslint-disable-next-line sonarjs/cognitive-complexity
export async function getCoords(): Promise<Coords> {
  try {
    let { lat, lng } = getSessionStorage('geo', 'Object', { lng: 0, lat: 0 })
    if (!(lat && lng)) {
      const coords: { latitude: number; longitude: number } = await new Promise((resolve, reject) => {
        if (Agent.native) {
          knbUse('getLocation', {
            success: async (result: { lat?: number; latitude?: number; lng?: number; longitude?: number }) => {
              resolve({
                latitude: result.lat || result.latitude || 0,
                longitude: result.lng || result.longitude || 0,
              })
            },
            fail: (err: any) => {
              reject(err)
            },
          })
        } else if (Agent.weixin) {
          // KNB封装的getLocation 取消不会调 fail，所以还是自己调用
          wxReady(() => {
            window.wx.getLocation({
              success: async (result: { lat?: number; latitude?: number; lng?: number; longitude?: number }) => {
                resolve({
                  latitude: result.lat || result.latitude || 0,
                  longitude: result.lng || result.longitude || 0,
                })
              },
              fail: (err: any) => {
                reject(err)
              },
              complete: (err: any) => {
                if (err && err.errMsg.indexOf('cancel') !== -1) {
                  reject(err)
                }
              },
            })
          })
        } else if ('geolocation' in navigator) {
          setTimeout(() => {
            reject()
          }, 3000)
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve(position.coords)
            },
            (err) => {
              reject(err)
            },
            {
              timeout: 2000,
            },
          )
        } else {
          reject('不支持定位')
        }
      })
      lat = Math.round(coords.latitude * 1000000) || 0
      lng = Math.round(coords.longitude * 1000000) || 0
    }
    if (isNodeProd()) {
      setSessionStorage('geo', { lat, lng })
    }
    // console.log('geo', lat, lng)
    return {
      lat,
      lng,
    }
  } catch (res) {
    // console.log('无法获取坐标', res)
    reportWarn({
      global: true,
      name: '获取定位失败',
      msg: res,
    })
    return {}
  }
}

let coords: Coords
const queue: ((coords: Coords) => void)[] = []
export async function concurrencyGetLocation(callback: (coords: Coords) => void) {
  if (coords) callback(coords)
  queue.push(callback)
  if (queue.length > 1) return
  if (!coords) {
    coords = await getCoords()
  }
  queue.forEach((callback) => {
    callback(coords)
  })
}
